import React from "react";
import TrackInfoTool from "../../../components/tools/TrackInfoTool";
import { BrandedAppsTable } from "../../../components/admin/brands/BrandedAppsTable";

export function AdminBrandedAppsRoute() {
  return (
    <>
      <BrandedAppsTable />
      <TrackInfoTool
        trackInfo={{
          name: "Admin – Branded Apps",
        }}
      />
    </>
  );
}
